interface IconCalendarPlusProps {
  active?: boolean;
  size?: number;
}

export const IconCalendarPlus = ({
  active,
  size = 24,
}: IconCalendarPlusProps) => {
  const stroke = active ? "#FF9934" : "#999999";
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="4"
        y="5.5"
        width="16"
        height="14"
        rx="1.5"
        stroke={stroke}
        strokeWidth="1.5"
      />
      <path
        d="M4 9.5H20"
        stroke={stroke}
        strokeWidth="1.5"
      />
      <path
        d="M8.5 3.5V6.5M15.5 3.5V6.5"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M12 12V17M9.5 14.5H14.5"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  );
};
